export var ActionType;
(function (ActionType) {
    ActionType["UpdateQuery"] = "UPDATE_QUERY";
    ActionType["Open"] = "OPEN";
    ActionType["Close"] = "CLOSE";
    ActionType["SetFocusedOption"] = "SET_FOCUSED_OPTION";
    ActionType["SetShowResetIcon"] = "SET_SHOW_RESET_ICON";
})(ActionType || (ActionType = {}));
//# sourceMappingURL=Select.interface.js.map